export default __webpack_public_path__ + "static/media/HeroDesign.70d4607c.png";